<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('CODE')">
        <inputvalidation :formerror="formError" name="code">
          <b-form-input type="text" v-model="formData.code"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="name">
          <b-form-input type="text" v-model="formData.name"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-5">
      <b-form-fieldset v-bind:label="$t('ADDRESS')">
        <inputvalidation :formerror="formError" name="address">
          <b-form-input type="text" v-model="formData.address"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-3">
      <b-form-fieldset v-bind:label="$t('POSTALCODE')">
        <inputvalidation :formerror="formError" name="postalCode">
          <b-form-input type="text" v-model="formData.postalCode"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('CITY')">
        <inputvalidation :formerror="formError" name="city">
          <b-form-input type="text" v-model="formData.city"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('PHONENUMBER')">
        <inputvalidation :formerror="formError" name="phoneNumber">
          <b-form-input type="text" v-model="formData.phoneNumber"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('PROVINCE')">
        <inputvalidation :formerror="formError" name="provinceId">
          <b-form-select :options="province.root" v-model="formData.provinceId" value-field="provinceId" text-field="name"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('STOREMANAGER')">
        <inputvalidation :formerror="formError" name="storeManagerId">
          <b-form-select :options="users.root" v-model="formData.storeManagerId" value-field="userId" text-field="username"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('REGIONALMANAGER')">
        <inputvalidation :formerror="formError" name="provinceId">
          <b-form-select :options="users.root" v-model="formData.regionalManagerId" value-field="userId" text-field="username"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('IMPORTORDER')">
        <inputvalidation :formerror="formError" name="importOrder">
          <b-form-input type="text" v-model="formData.importOrder"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('IMPORTCOLUMN')">
        <inputvalidation :formerror="formError" name="importColumn">
          <b-form-input type="text" v-model="formData.importColumn"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>

  <div class="clear20">&nbsp;</div>
  <div class="clear20">&nbsp;</div>

  <div class="form-row mb-2" v-for="item in formData.workingTimeOut">
    <div class="col-sm-2">
      <label>{{$t(item.text)}}</label>
    </div>
    <div class="col-sm-5">
      <b-form-input type="text" v-model="item.open" :placeholder="$t('OPEN')"></b-form-input>
    </div>
    <div class="col-sm-5">
      <b-form-input type="text" v-model="item.close" :placeholder="$t('CLOSE')"></b-form-input>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'Blog',
  props: ['formData', 'formError', 'province', 'users'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>
